import styles from "./VolunteerProfile.module.scss";
import { useTranslation } from "../i18n";
import { useState } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { VolunteerPersonalInfo } from "../components/VolunteerPersonalInfo/VolunteerPersonalInfo";
import { VolunteerProfileSkillsInterest } from "../components/VolunteerProfileSkillsInterest/VolunteerProfileSkillsInterest";
import { Box, Button } from "@mui/material";
import { RemoveAccountDialog } from "../components/RemoveAccountDialog/RemoveAccountDialog";
import { useParams } from "react-router-dom";

export const VolunteerProfile = () => {
  const { t } = useTranslation();
  const { volunteerId } = useParams<{ volunteerId: string }>();
  const [tab, setTab] = useState<number>(1);
  const [deleteAccountModal, setDeleteAccountModal] = useState<boolean>(false);

  return (
    <div className={styles.volunteerProfile}>
      <TabContext value={tab.toString()}>
        <TabList
          onChange={(_e, value) => setTab(Number(value))}
          aria-label="volunteer-profile-tabs"
          className={styles.tabList}
        >
          <Tab
            label={t("orgProfile.basicInfo")}
            value="1"
            className={styles.tab}
          />
        </TabList>
        <div className={styles.separator}></div>
        <TabPanel value="1" className={styles.content}>
          <VolunteerPersonalInfo />
          <VolunteerProfileSkillsInterest />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => setDeleteAccountModal(true)}
            >
              {t("orgProfile.deleteAccount")}
            </Button>
          </Box>
        </TabPanel>
      </TabContext>
      <RemoveAccountDialog
        id={volunteerId!}
        accountType="volunteer"
        dialogOpen={deleteAccountModal}
        setDialogOpen={setDeleteAccountModal}
      />
    </div>
  );
};
